export enum ExtremeTypes {
	workStyle = 'workStyle',
	performance = 'performance',
}

export interface IExtremeSetData
	extends Record<
		IExtremeSetNames,
		{
			text: string;
			error?: string;
		}
	> {
	id?: number;
}

export interface IExtremeSet extends Record<IExtremeSetNames, string> {
	id?: number;
}

export enum IExtremeSetNames {
	firstMinExtreme = 'firstMinExtreme',
	firstMaxExtreme = 'firstMaxExtreme',
	secondMinExtreme = 'secondMinExtreme',
	secondMaxExtreme = 'secondMaxExtreme',
	thirdMinExtreme = 'thirdMinExtreme',
	thirdMaxExtreme = 'thirdMaxExtreme',
	firstSliderName = 'firstSliderName',
	secondSliderName = 'secondSliderName',
	thirdSliderName = 'thirdSliderName',
}
